import React from "react";
import "./Card.css";

function Card({ Image, Title }) {
  return (
    <div className="container-card">
      <div className="card-parrent">
        <img alt="" aria-hidden="true" role="presentation" src={Image} />
        <h3>{Title}</h3>
        <div className="rating">
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star"></i>
          <i className="fa-solid fa-star-half-stroke"></i>
        </div>
      </div>
    </div>
  );
}

export default Card;
